import Wrapper from "./style"

export const Cover = () => {
    return (
        <Wrapper>
            <div className="cover">
                <div className="left">
                    <h1>Market Sizing Assets</h1>
                    <p>Analyses and insights from the McKinsey Knowledge Base,<br />tailored to your unique use case</p>
                </div>
            </div>
        </Wrapper>
    )
}